<!-- [モーダル] -->
<div
  #modalContents
  class="l-modal01__contents l-modal01__contents--w384 js-modal-contents"
  aria-modal="true"
  role="dialog"
  aria-labelledby="passenger-selector-modal-title"
>
  <!-- [ヘッダ] -->
  <div #modalHead class="l-modal01__header js-modal-head">
    <div class="p-modal-head01">
      <h1
        id="passenger-selector-modal-title"
        class="p-modal-head01__title"
        [innerHTML]="'label.spesifyPax.title' | staticMsg"
        aria-hidden="true"
      ></h1>
      <button
        id="passenger-selector-modal-button-1_shp"
        class="p-modal-head01__close js-modal-close"
        (click)="clickCancel()"
      >
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>

  <div #modalBody class="l-modal01__body js-modal-body">
    <ul class="c-passenger-select-list">
      <!-- [大人] -->
      <li class="c-passenger-select-list__item">
        <div class="c-passenger-select-list__item-head">
          <p class="c-passenger-select-list__item-label" [innerHTML]="'label.adult' | staticMsg"></p>
          <p class="c-passenger-select-list__item-lead" [innerHTML]="'label.from16Age' | staticMsg"></p>
        </div>
        <div class="c-passenger-select-list__item-body">
          <button
            id="passenger-selector-modal-button-2_shp"
            class="c-passenger-select-list__item-button c-passenger-select-list__item-button--minus"
            aria-controls="adultNumber"
            (click)="addAdultCount(-1)"
            [disabled]="!isAdultMinusButtonEnabled"
          >
            <span class="u-visually-hidden" [innerHTML]="'reader.decrease.adult' | staticMsg"></span>
          </button>
          <div
            id="adultNumber"
            class="c-passenger-select-list__item-value"
            aria-live="polite"
            [innerHTML]="'paxSelect.adult' | staticMsg : { '0': adultCount }"
          ></div>
          <button
            id="passenger-selector-modal-button-3_shp"
            class="c-passenger-select-list__item-button c-passenger-select-list__item-button--plus"
            aria-controls="adultNumber"
            (click)="addAdultCount(1)"
            [disabled]="!isAdultPlusButtonEnabled"
          >
            <span class="u-visually-hidden" [innerHTML]="'reader.increase.adult' | staticMsg"></span>
          </button>
        </div>
      </li>
      <!-- [ヤングアダルト] -->
      <li class="c-passenger-select-list__item">
        <div class="c-passenger-select-list__item-head">
          <p class="c-passenger-select-list__item-label" [innerHTML]="'label.youngAdult.flightSearch' | staticMsg"></p>
          <p class="c-passenger-select-list__item-lead" [innerHTML]="'label.from12To15Age' | staticMsg"></p>
        </div>
        <div class="c-passenger-select-list__item-body">
          <button
            id="passenger-selector-modal-button-4_shp"
            class="c-passenger-select-list__item-button c-passenger-select-list__item-button--minus"
            aria-controls="youngAdultNumber"
            (click)="addYoungAdultCount(-1)"
            [disabled]="!isYoungAdultMinusButtonEnabled"
          >
            <span class="u-visually-hidden" [innerHTML]="'reader.decrease.youngAdult' | staticMsg"></span>
          </button>
          <div
            id="youngAdultNumber"
            class="c-passenger-select-list__item-value"
            aria-live="polite"
            [innerHTML]="'paxSelect.youngAdult' | staticMsg : { '0': youngAdultCount }"
          ></div>
          <button
            id="passenger-selector-modal-button-5_shp"
            class="c-passenger-select-list__item-button c-passenger-select-list__item-button--plus"
            aria-controls="youngAdultNumber"
            (click)="addYoungAdultCount(1)"
            [disabled]="!isYoungAdultPlusButtonEnabled"
          >
            <span class="u-visually-hidden" [innerHTML]="'reader.increase.youngAdult' | staticMsg"></span>
          </button>
        </div>
      </li>
      <!-- [小児] -->
      <li class="c-passenger-select-list__item">
        <div class="c-passenger-select-list__item-head">
          <p class="c-passenger-select-list__item-label" [innerHTML]="'label.child' | staticMsg"></p>
          <p
            class="c-passenger-select-list__item-lead"
            [innerHTML]="this.isChild3To11 ? ('label.from3To11Age' | staticMsg) : ('label.from2To11Age' | staticMsg)"
          ></p>
        </div>
        <div class="c-passenger-select-list__item-body">
          <button
            id="passenger-selector-modal-button-6_shp"
            class="c-passenger-select-list__item-button c-passenger-select-list__item-button--minus"
            aria-controls="childrenNumber"
            (click)="addChildCount(-1)"
            [disabled]="!isChildMinusButtonEnabled"
          >
            <span class="u-visually-hidden" [innerHTML]="'reader.decrease.child' | staticMsg"></span>
          </button>
          <div
            id="childrenNumber"
            class="c-passenger-select-list__item-value"
            aria-live="polite"
            [innerHTML]="'paxSelect.child' | staticMsg : { '0': childCount }"
          ></div>
          <button
            id="passenger-selector-modal-button-7_shp"
            class="c-passenger-select-list__item-button c-passenger-select-list__item-button--plus"
            aria-controls="childrenNumber"
            (click)="addChildCount(1)"
            [disabled]="!isChildPlusButtonEnabled"
          >
            <span class="u-visually-hidden" [innerHTML]="'reader.increase.child' | staticMsg"></span>
          </button>
        </div>
      </li>
      <!-- [幼児] -->
      <ng-container *ngIf="this.isInfantCountShow">
        <li class="c-passenger-select-list__item">
          <div class="c-passenger-select-list__item-head">
            <p class="c-passenger-select-list__item-label" [innerHTML]="'label.infant' | staticMsg"></p>
            <p
              class="c-passenger-select-list__item-lead"
              [innerHTML]="this.isInfant0To1 ? ('label.from0To1Age' | staticMsg) : ('label.from0To2age' | staticMsg)"
            ></p>
          </div>
          <div class="c-passenger-select-list__item-body">
            <button
              id="passenger-selector-modal-button-8_shp"
              class="c-passenger-select-list__item-button c-passenger-select-list__item-button--minus"
              aria-controls="infantNumber"
              (click)="addInfantCount(-1)"
              [disabled]="!isInfantMinusButtonEnabled"
            >
              <span class="u-visually-hidden" [innerHTML]="'reader.decrease.infant' | staticMsg"></span>
            </button>
            <div
              id="infantNumber"
              class="c-passenger-select-list__item-value"
              aria-live="polite"
              [innerHTML]="'paxSelect.infant' | staticMsg : { '0': infantCount }"
            ></div>
            <button
              id="passenger-selector-modal-button-9_shp"
              class="c-passenger-select-list__item-button c-passenger-select-list__item-button--plus"
              aria-controls="infantNumber"
              (click)="addInfantCount(1)"
              [disabled]="!isInfantPlusButtonEnabled"
            >
              <span class="u-visually-hidden" [innerHTML]="'reader.increase.infant' | staticMsg"></span>
            </button>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
  <!-- [フッター] -->
  <div #modalFooter class="l-modal01__footer js-modal-footer">
    <div class="p-modal-foot01">
      <button
        id="passenger-selector-modal-button-10_shp"
        class="c-btn-primary c-btn-primary--s c-btn-primary--min-w100"
        (throttleClick$)="clickApply()"
        [disabled]="!isApplyEnabled"
        aswThrottleClick
      >
        <span class="c-btn-primary__text" [innerHTML]="'label.apply1' | staticMsg"></span>
      </button>
    </div>
  </div>
</div>
<!-- //[モーダル] -->
